import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
// eslint-disable-next-line @typescript-eslint/triple-slash-reference -- propagates .png declarations to consumer packages
/// <reference path="../assets.d.ts" />
import { Language } from "@mui/icons-material";
import { Box, IconButton, Menu, MenuItem, Tooltip, useMediaQuery } from "@mui/material";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocalStorage } from "usehooks-ts";
import zhHkLogo from "../assets/flags/china.png";
import frFrLogo from "../assets/flags/france.png";
import esUsLogo from "../assets/flags/mexico.png";
import enUsLogo from "../assets/flags/usa.png";
export const LanguageMenu = ()=>{
    const [current, setCurrent] = useLocalStorage('language', 'enUs');
    const isSm = useMediaQuery((theme)=>theme.breakpoints.down('sm'));
    const translation = useTranslation();
    const [anchorEl, setAnchorEl] = useState(null);
    const languages = {
        enUs: {
            image: enUsLogo,
            label: translation.t('languages.enUs', 'English (United States)')
        },
        esUs: {
            image: esUsLogo,
            label: translation.t('languages.esUs', 'Spanish (United States)')
        },
        frFr: {
            image: frFrLogo,
            label: translation.t('languages.frFr', 'French (France)')
        },
        zhHk: {
            image: zhHkLogo,
            label: translation.t('languages.zhHk', 'Chinese (Hong Kong)')
        }
    };
    const onOpen = (event)=>{
        setAnchorEl(event.currentTarget);
    };
    const onClose = ()=>{
        setAnchorEl(null);
    };
    const onChange = async (language)=>{
        setCurrent(language);
        await translation.i18n.changeLanguage(language);
        onClose();
    };
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Tooltip, {
                title: translation.t('pages.root.languageTooltip'),
                children: /*#__PURE__*/ _jsx(IconButton, {
                    "data-testid": "changeLanguage",
                    onClick: onOpen,
                    children: /*#__PURE__*/ _jsx(Language, {
                        fontSize: isSm ? 'small' : 'large',
                        sx: (theme)=>({
                                color: theme.palette.primary.contrastText
                            })
                    })
                })
            }),
            /*#__PURE__*/ _jsx(Menu, {
                anchorEl: anchorEl,
                onClose: onClose,
                open: Boolean(anchorEl),
                children: Object.keys(languages).map((language)=>/*#__PURE__*/ _jsxs(MenuItem, {
                        "data-testid": language,
                        onClick: ()=>onChange(language),
                        selected: language === current,
                        children: [
                            /*#__PURE__*/ _jsx(Box, {
                                alt: languages[language].label,
                                component: "img",
                                height: 18,
                                mr: 1,
                                src: languages[language].image,
                                width: 18
                            }),
                            languages[language].label
                        ]
                    }, language))
            })
        ]
    });
};
LanguageMenu.displayName = 'LanguageMenu';

//# sourceMappingURL=LanguageMenu.js.map